export default __webpack_public_path__ + "static/media/Ring_AO2.e278e437.png";